import { applicationName } from 'enum/application.enum';
import { User } from 'models/user';
import { axiosEndPoint } from 'utils/axios';

const path = '/authentication/login';

export const signin = async (payload: { email: string; password: string }) => {
  const response = await axiosEndPoint.post<User>(path, {
    email: payload.email,
    password: payload.password,
    application: applicationName.BACKOFFICE,
  });
  axiosEndPoint.defaults.headers.common.Authorization = `Bearer ${response.data.accessToken}`;

  return response.data;
};
